// extracted by mini-css-extract-plugin
export var asideContact = "component-module--asideContact--8fb34";
export var asideContactDetails = "component-module--asideContactDetails--48185";
export var asideContactDetailsBlock = "component-module--asideContactDetailsBlock--fc502";
export var asideContactTextBlock = "component-module--asideContactTextBlock--56b81";
export var asideContent = "component-module--asideContent--fb7af";
export var asideContentWrapper = "component-module--asideContentWrapper--99a90";
export var asideIcon = "component-module--asideIcon--ae653";
export var asideIconText = "component-module--asideIconText--6cf13";